import { useEffect, useRef, useState } from 'react';

const stats = [
  { val: '80社+', label: '支援実績', sub: '製造・IT・サービス業など' },
  { val: '42%', label: '会議時間削減', sub: '平均（導入3ヶ月後）' },
  { val: '3倍', label: '意思決定スピード向上', sub: '対前年比' },
  { val: '96%', label: '顧客満足度', sub: '5段階中4以上の評価' },
  { val: '約2ヶ月', label: 'ROI回収期間', sub: '平均投資対効果' },
];

const voices = [
  {
    name: '田中 誠一',
    role: '株式会社テクノア / 代表取締役（従業員120名）',
    comment:
      '毎週2時間の役員会議が45分になりました。しかも決定事項の実行率が劇的に上がり、組織のスピードが変わりました。',
    init: '田',
  },
  {
    name: '佐藤 美咲',
    role: 'クリエイティブデザイン株式会社 / 事業部長（従業員65名）',
    comment:
      '「また同じ議題だ…」という疲弊感がなくなりました。会議が終わると次のアクションが明確で、チームのモチベーションが上がりました。',
    init: '佐',
  },
  {
    name: '鈴木 健太',
    role: 'フューチャーテック株式会社 / 管理本部長（従業員200名）',
    comment:
      'AI議事録の導入だけで、月に40時間の事務作業が削減されました。管理職が本来の仕事に集中できるようになっています。',
    init: '鈴',
  },
];

export default function TrustSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.06 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      id="trust"
      className="py-24 px-4 md:px-10"
      style={{ backgroundColor: '#111111' }}
    >
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div
          className="text-center mb-14 transition-all duration-700"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)' }}
        >
          <span
            className="inline-block px-3 py-1 text-xs font-bold tracking-widest uppercase text-[#C0392B] border border-[#C0392B]/30 rounded-full mb-4"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Results
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            数字が証明する、実績
          </h2>
          <p className="text-sm text-white/40" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
            ※以下は過去の支援実績データに基づく参考値です
          </p>
        </div>

        {/* Stats Grid */}
        <div
          className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-16 transition-all duration-700"
          style={{ opacity: visible ? 1 : 0, transitionDelay: '0.2s' }}
        >
          {stats.map((s, i) => (
            <div key={i} className="text-center p-5 rounded-lg bg-white/5 border border-white/8">
              <div
                className="text-2xl md:text-3xl font-bold text-[#C0392B] mb-1"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {s.val}
              </div>
              <div
                className="text-xs font-bold text-white mb-1"
                style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
              >
                {s.label}
              </div>
              <div className="text-xs text-white/30" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                {s.sub}
              </div>
            </div>
          ))}
        </div>

        {/* Voices */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {voices.map((v, i) => (
            <div
              key={i}
              className="p-6 rounded-lg bg-white/5 border border-white/8 flex flex-col gap-4 transition-all duration-700"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(24px)',
                transitionDelay: `${0.3 + i * 0.1}s`,
              }}
            >
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((s) => (
                  <i key={s} className="ri-star-fill text-[#C0392B] text-xs" />
                ))}
              </div>
              <p
                className="text-sm text-white/70 leading-relaxed flex-1"
                style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
              >
                &ldquo;{v.comment}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-white/8">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#C0392B]/20 text-[#C0392B] font-bold text-sm flex-shrink-0">
                  {v.init}
                </div>
                <div>
                  <p
                    className="text-xs font-bold text-white"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    {v.name}
                  </p>
                  <p className="text-xs text-white/30" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    {v.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
